<template>
  <Loading v-if="is_loading()" @next="advance_from_loading" @update_gain="update_gain" :loaded_audio="audioLoadedCounter" :total_audio="getNumAudio" :loaded_video="videoLoadedCounter" :total_video="1" />
  <IntroVideo v-if="is_introvid()" @next="set_interactive" :vid_src="vidData" @home="set_introvid"/>
  <Interactive v-if="is_interactive()" :gain_delta="delta_gain_db" :audioCtx="audioCtx" :gainNodes="gainNodes" @b2c="set_b2c" @b2b="set_b2b" @back="set_introvid" @home="set_introvid"/>
  <!-- <B2B v-if="is_b2b()" @back="set_interactive" @home="set_introvid"/>
  <B2C v-if="is_b2c()" @back="set_interactive" @home="set_introvid"/> -->
</template>

<script>
import Loading from "./components/Loading";
import IntroVideo from "./components/IntroVideo"
import Interactive from "./components/Interactive"
import B2B from "./components/b2b"
import B2C from "./components/b2c"

const RUN_STATES = {
  LOADING: "loading",
  INTROVID: "introVID",
  INTERACTIVE: "interactive",
  VIDEO: "video",
  B2B: "b2b",
  B2C: "b2c"
}

// pure testing
function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

// const ASSET_URL_PREFIX = "https://four-interval-1st.s3.eu-west-2.amazonaws.com/assets/"
const ASSET_URL_PREFIX = "./assets/loops/"

export default {
  name: "App",
  components: {
    Loading,
    IntroVideo,
    Interactive,
    B2B,
    B2C
  },
  data() {
    return {
      urlSnds: [
        { url: ASSET_URL_PREFIX + 'elec_loss_40.mp3' },
        { url: ASSET_URL_PREFIX + 'elec_loss_60.mp3' },
        { url: ASSET_URL_PREFIX + 'elec_loss_70.mp3' },
        { url: ASSET_URL_PREFIX + 'hot_loss_40.mp3' },
        { url: ASSET_URL_PREFIX + 'hot_loss_60.mp3' },
        { url: ASSET_URL_PREFIX + 'hot_loss_70.mp3' },
        { url: ASSET_URL_PREFIX + 'pod_loss_40.mp3' },
        { url: ASSET_URL_PREFIX + 'pod_loss_60.mp3' },
        { url: ASSET_URL_PREFIX + 'pod_loss_70.mp3' },
        { url: ASSET_URL_PREFIX + 'movie_loss_40.mp3' },
        { url: ASSET_URL_PREFIX + 'movie_loss_60.mp3' },
        { url: ASSET_URL_PREFIX + 'movie_loss_70.mp3' },
        
        { url: ASSET_URL_PREFIX + 'elec_loss_40_loudnessISO.mp3' },
        { url: ASSET_URL_PREFIX + 'elec_loss_60_loudnessISO.mp3' },
        { url: ASSET_URL_PREFIX + 'elec_loss_70_loudnessISO.mp3' },
        { url: ASSET_URL_PREFIX + 'hot_loss_40_loudnessISO.mp3' },
        { url: ASSET_URL_PREFIX + 'hot_loss_60_loudnessISO.mp3' },
        { url: ASSET_URL_PREFIX + 'hot_loss_70_loudnessISO.mp3' },        
        // { url: ASSET_URL_PREFIX + 'pod_loss_40_tech4_v2_voice.mp3' },
        // { url: ASSET_URL_PREFIX + 'pod_loss_60_tech4_v2_voice.mp3' },
        // { url: ASSET_URL_PREFIX + 'pod_loss_75_tech4_v2_voice.mp3' },
        { url: ASSET_URL_PREFIX + 'pod_loss_40_loudnessISO.mp3' },
        { url: ASSET_URL_PREFIX + 'pod_loss_60_loudnessISO.mp3' },
        { url: ASSET_URL_PREFIX + 'pod_loss_70_loudnessISO.mp3' },
        { url: ASSET_URL_PREFIX + 'movie_loss_40_loudnessISO.mp3' },
        { url: ASSET_URL_PREFIX + 'movie_loss_60_loudnessISO.mp3' },
        { url: ASSET_URL_PREFIX + 'movie_loss_70_loudnessISO.mp3' },
      ],      
      audioBufferMaster: [],
      vidData: [],
      audioLoadedCounter: 0,
      videoLoadedCounter: 0,
      delta_gain_db: 0,
      runState: RUN_STATES.LOADING,
      audioCtx: null,
      gainNodes: [],
      sourceNodes: []
    };
  },

  computed: {
    getNumAudio() {
      return this.urlSnds.length;
    }
  },

  async mounted() {
    this.vidData = await fetch('assets/vids/intro_mb.mp4')
      .then(res => res.arrayBuffer())
      .then(blob => new Blob([blob],{"type" : "video\/mp4"}))
      .then(url => URL.createObjectURL(url))

    this.videoLoadedCounter++

    let AudioContext = window.AudioContext || window.webkitAudioContext;
    this.audioCtx = new AudioContext();

    for (var ii = 0; ii < this.urlSnds.length; ii++) {
      const audioBuffer = await fetch(this.urlSnds[ii].url)
        .then(res => res.arrayBuffer())
        .then(ArrayBuffer => this.audioCtx.decodeAudioData(ArrayBuffer));

      this.audioBufferMaster.push(audioBuffer);

      await sleep(20);
      this.audioLoadedCounter++;
    }
  },

  methods: {
    update_gain(val) {
      this.delta_gain_db = val
    },

    advance_from_loading() {
      for (var ii = 0; ii < this.audioBufferMaster.length; ii++) {
        this.gainNodes.push(this.audioCtx.createGain());
        this.gainNodes[ii].connect(this.audioCtx.destination);
        this.gainNodes[ii].gain.value = 0;
      }

      for (var ii = 0; ii < this.audioBufferMaster.length; ii++) {
        this.sourceNodes.push(this.audioCtx.createBufferSource());
        this.sourceNodes[ii].buffer = this.audioBufferMaster[ii];
        this.sourceNodes[ii].connect(this.gainNodes[ii]);
      }
      const startTime = this.audioCtx.currentTime + 0.25; // give us an epoch to get everything in order async            
      for (var ii = 0; ii < this.audioBufferMaster.length; ii++) {
        this.sourceNodes[ii].loop = true
        this.sourceNodes[ii].start(startTime);
      }

      this.runState = RUN_STATES.INTROVID;
    },

    set_introvid()      { this.runState = RUN_STATES.INTROVID; },
    set_interactive()   { this.runState = RUN_STATES.INTERACTIVE; },
    set_b2b()           { this.runState = RUN_STATES.B2B; },
    set_b2c()           { this.runState = RUN_STATES.B2C; },

    is_loading()        { return this.runState == RUN_STATES.LOADING; },
    is_introvid()       { return this.runState == RUN_STATES.INTROVID; },
    is_interactive()    { return this.runState == RUN_STATES.INTERACTIVE; },
    is_b2b()            { return this.runState == RUN_STATES.B2B; },
    is_b2c()            { return this.runState == RUN_STATES.B2C; }
  }
};
</script>

<style>

* {
  margin: 0;
  padding: 0;
}

@font-face {
  font-family: "MontblancType-Regular";
  src: local("MontblancType-Regular"),
   url(./font/MontblancType-Regular.ttf) format("truetype");
}

#app {
  height: 100vh;
  font-family: "MontblancType-Regular";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}

button.green {
  display: inline-block;
  padding: 5px 20px;
  border: 0.1em solid #ffffff;
  margin: 4px 2px;
  border-radius: 12px;
  box-sizing: border-box;
  text-decoration: none;
  font-size: 18pt;
  color: #ffffff;
  background-color: #34bd82;
  cursor: pointer;
}

button.green:hover {
  color: #000000;
  background-color: #6df0b7;
}

button.green:disabled {
  color: #000000;
  background-color: rgb(210, 210, 210);
}
</style>
